let CoinMatchConfig = require("activity/CoinMatchActivity/CoinMatchConfig")
let CoinMatchLogic = require("activity/CoinMatchActivity/CoinMatchLogic")

let CoinMatchPosterPanel = xClass("CoinMatchPosterPanel", BasePanel, () => { return cc.CSLoader.createNode(CoinMatchConfig.poster.csb); })

CoinMatchPosterPanel.preloadResPromise = function(withMask = false) {
    if (CoinMatchConfig.poster.resList.length > 0) {
        return preloadWithLoadingPromise(CoinMatchConfig.poster.resList, withMask);
    } else {
        return Promise.resolve();
    }
}

CoinMatchPosterPanel.show = function(onShowSuccess, onShowFail, onPanelClose) {
    CoinMatchPosterPanel.preloadResPromise()
        .then(()=> {
            let panel = CoinMatchPosterPanel.create();
            panel.popup(true);
            if(onPanelClose != null)
                panel.on(BasePanelEvent.Close, onPanelClose);
            
            if (onShowSuccess != null)  
                onShowSuccess();
        })
        .catch((err)=> {
            console.error("CoinMatchPosterPanel show failed.", err);
            LogToLogCenter(err);
            if (onShowFail != null) {
                onShowFail(err);
            }
        });
}

CoinMatchPosterPanel.prototype.ctor = function () {
    BasePanel.prototype.ctor.call(this);
    this.initUI();
}

CoinMatchPosterPanel.prototype.initUI = function () {
    this.btnMain = GetChildByPath(this, CoinMatchConfig.poster.mainBtnLayer);
    quickBuildBtn(this.btnMain, UIGroupButton, PushBounceAnim, ()=> this.onMainBtnClick(), true);

    this.btnClose = GetChildByPath(this, CoinMatchConfig.poster.closeBtnLayer);
    quickBuildBtn(this.btnClose, UIButton, PushBounceAnim, ()=> this.onClose(), true);

    this.initDetail();
}

CoinMatchPosterPanel.prototype.initDetail = function() {
    this.btnMain.setText(CoinMatchConfig.strings.posterStart);

    let list = CoinMatchConfig.poster.finalLayers;
    list.forEach((name)=> {
        let child = GetChildByPath(this, CoinMatchConfig.poster[name]);
        child.setVisible(false);
    });
}

CoinMatchPosterPanel.prototype.onEnter = function() {
    BasePanel.prototype.onEnter.call(this);
}

CoinMatchPosterPanel.prototype.onMainBtnClick = function() {
    this.onClose(null, "main");
}

CoinMatchPosterPanel.prototype.cleanup = function() {
    if (CoinMatchConfig.poster.resList.length > 0)
        ResManager.release(CoinMatchConfig.poster.resList);

    BasePanel.prototype.cleanup.call(this);
}

module.exports = CoinMatchPosterPanel